import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled, alpha, createTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_NEUTRAL_MID_GREY, PROMETHEAN_TEXT, PROMETHEAN_DARK_PURPLE, PROMETHEAN_TEXT_HEADER } from '../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_H3 } from '../../styles/typography/typography';
import { PROMETHEAN_BREAKPOINT_XL, PROMETHEAN_BREAKPOINT_XXL, PROMETHEAN_BREAKPOINT_SM, PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT, PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT_MD } from '../../styles/breakpoints/breakpoints';
export var marketingTemplateTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 1215,
      md: 1440,
      lg: 1920,
      xl: 2500
    }
  }
});
export var COLUMN_BREAKPOINT = 1281;
var sharedLayout = _defineProperty(_defineProperty(_defineProperty(_defineProperty({
  width: 1536
}, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_XXL, "px)"), {
  width: 1536
}), "@media screen and (max-width: ".concat(1536 + 128, "px)"), {
  width: '100%',
  maxWidth: "".concat(1536 + 128, "px"),
  padding: '0 80px'
}), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
  width: '100%',
  padding: '0 64px'
}), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  width: '100%',
  padding: '0 24px'
});
export var StyledMarketingRoot = styled(Stack)({
  background: PROMETHEAN_NEUTRAL_WHITE,
  'div:nth-of-type(2)': {
    '&.EmbersTemplate-marketing-content ': {
      marginTop: 64
    }
  },
  'div:not(:nth-of-type(2))': {
    '&.EmbersTemplate-marketing-content ': {
      marginTop: 32
    }
  },
  '.EmbersTemplate-marketingCustom-root': _objectSpread(_objectSpread({}, sharedLayout), {}, {
    width: '100%'
  })
});
// Column
export var StyledColumnSectionGroup = styled('div')(function (_ref) {
  var wrapSize = _ref.wrapSize;
  return _objectSpread(_objectSpread({}, sharedLayout), {}, _defineProperty({
    margin: '64px auto',
    display: 'flex',
    flexDirection: 'row',
    columnGap: 48
  }, "@media screen and (max-width: ".concat(wrapSize || PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
    margin: '32px 0',
    flexDirection: 'column',
    rowGap: 48
  }));
});
export var StyledColumnSection = styled('div')(function (_ref2) {
  var wrapSize = _ref2.wrapSize,
    wrapDirection = _ref2.wrapDirection;
  return {
    '&.EmbersTemplate-marketingColumns-selection-root': _defineProperty({
      flex: '1 0 0',
      display: 'flex',
      flexDirection: 'column',
      '.EmbersTemplate-marketingColumns-selection-circle': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        width: 72,
        height: 72,
        i: {
          fontSize: '52px',
          '&:before': {
            color: PROMETHEAN_NEUTRAL_WHITE
          }
        }
      },
      '.EmbersTemplate-marketingColumns-selection-content': {
        marginTop: 16,
        '.EmbersTemplate-marketingColumns-selection-title': {
          color: PROMETHEAN_TEXT_HEADER
        },
        '.EmbersTemplate-marketingColumns-selection-body': {
          marginTop: 8
        }
      }
    }, "@media screen and (max-width: ".concat(wrapSize || PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), _objectSpread({}, wrapDirection === 'row' ? {
      display: 'flex',
      flexDirection: 'row',
      '.EmbersTemplate-marketingColumns-selection-content': {
        marginTop: 0,
        marginLeft: 16
      }
    } : {}))
  };
});

// Image
export var StyledMarketingImage = styled('div')(function (_ref3) {
  var wrapSize = _ref3.wrapSize;
  return _objectSpread(_objectSpread({}, sharedLayout), {}, _defineProperty({
    display: 'flex',
    flexDirection: 'row',
    columnGap: 64,
    margin: '24px auto'
  }, "@media screen and (max-width: ".concat(wrapSize || PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT_MD, "px)"), {
    flexDirection: 'column',
    rowGap: 32,
    img: {
      alignSelf: 'center'
    }
  }));
});

// Banner
export var StyledMarketingBanner = styled('div')(_defineProperty({
  width: '100%',
  background: PROMETHEAN_DARK_PURPLE,
  '&.EmbersTemplate-marketingBanner': {
    '&-expandedBy-picture': {
      '.EmbersTemplate-marketingBanner-content-root': {
        padding: 0,
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  '.EmbersTemplate-marketingBanner-content-appInfo-titleLine': {
    flexDirection: 'column',
    '.EmbersTemplate-marketingBanner-content-appInfo-titleLine-text h1': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_H3), {}, {
      color: PROMETHEAN_NEUTRAL_WHITE
    })
  },
  '.EmbersTemplate-marketingBanner-content-appInfo-other': {
    marginTop: 10
  }
}));
export var StyledMarketingBannerContent = styled('div')(_objectSpread(_objectSpread({
  display: 'flex',
  justifyContent: 'space-between'
}, sharedLayout), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty({
  margin: '56px auto',
  '.EmbersTemplate': {
    '&-marketingBanner-content': {
      '&-root': {
        '.MuiTypography-root': {
          color: PROMETHEAN_NEUTRAL_WHITE
        }
      },
      '&-appInfo': _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        width: 614
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_XL + 1, "px)"), {
        width: 512
      }), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        width: '100%'
      }), '&-titleLine', _defineProperty(_defineProperty(_defineProperty({
        display: 'flex'
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        justifyContent: 'center',
        alignItems: 'center'
      }), '&-logo', _defineProperty({
        width: 72,
        height: 72,
        marginRight: 24
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
        marginRight: 0
      })), '&-description', {
        marginTop: 8
      })), '&-other', _defineProperty({
        marginLeft: 96
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        marginLeft: 0
      })),
      '&-divider': {
        margin: '32px 0',
        borderColor: alpha(PROMETHEAN_NEUTRAL_WHITE, 0.3)
      }
    },
    '&-marketingBanner-picture': {
      '&-area': _defineProperty({
        position: 'relative'
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        '&> *': {
          display: 'block',
          maxWidth: '100%',
          minWidth: 350
        }
      }),
      '&-box': {
        position: 'absolute',
        right: 0,
        top: 0
      }
    },
    '&-marketingBanner-signIn': {
      '.MuiTypography-root': {
        color: PROMETHEAN_NEUTRAL_WHITE
      },
      '&-createAccount': _defineProperty({
        marginTop: 40
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        marginTop: 0
      })
    },
    '&-marketingBanner-extend-area': {
      '.MuiTypography-root': {
        color: PROMETHEAN_NEUTRAL_WHITE
      }
    },
    /* Styling for generic/custom button section */
    '&-marketingBanner-button-area': {
      '.MuiTypography-root': {
        color: PROMETHEAN_NEUTRAL_WHITE
      },
      '.MuiButtonBase-root': _defineProperty({
        marginTop: 40
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        marginTop: 0
      })
    }
  }
}, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT, "px)"), {
  '.EmbersTemplate-marketingBanner-picture': {
    '&-area': {
      maxWidth: 'calc(100% - 512px)',
      '& > *': {
        maxWidth: '100%'
      }
    }
  }
}), "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_XL, "px)"), {
  '.EmbersTemplate-marketingBanner-picture': {
    '&-area': {
      maxWidth: 'calc(100% - 612px)'
    }
  }
}), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
  justifyContent: 'center',
  textAlign: 'center',
  flexDirection: 'column',
  '.EmbersTemplate': {
    '&-marketingBanner-content': {
      '&-appInfo': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '&-other': {
          marginTop: 40,
          marginLeft: 0
        }
      },
      '&-downloadArea': {
        button: {
          margin: '0 auto 32px'
        }
      }
    },
    '&-marketingBanner-picture': {
      '&-area': {
        position: 'static!important',
        margin: '40px auto'
      },
      '&-box': {
        position: 'static!important',
        width: '100%'
      }
    },
    '&-marketingBanner-signIn-area': {
      '.MarketingBanner-signIn': {
        '&-createAccount': {
          marginTop: 0
        }
      }
    },
    '&-marketingBanner-extend-area > *': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }
}), "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  padding: '0 24px',
  '.EmbersTemplate': {
    '&-marketingBanner-content': {
      '&-appInfo': {
        '&-titleLine': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          '&-logo': {
            marginRight: 0,
            marginBottom: 24
          },
          '&-text': {
            h2: _objectSpread({}, PROMETHEAN_TYPOGRAPHY_H3)
          }
        },
        '&-other': {
          marginTop: '24px !important'
        }
      }
    }
  }
})));

// Circle
export var StyledCicleArea = styled('div')(_defineProperty(_defineProperty({
  width: 480,
  '@media screen and (max-width: 544px)': {
    width: 'calc(100vw - 128px)'
  }
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  width: '100%'
}), '.EmbersTemplate-marketingCircle', {
  '&-product': {
    width: '100%',
    borderRadius: '50%',
    '>*': {
      width: '100%',
      height: '100%'
    },
    '&-description': {
      fontFamily: 'Noto Sans',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '21px',
      textAlign: 'center',
      color: PROMETHEAN_TEXT,
      marginTop: 24
    }
  }
}));
export var StyledRowLayout = styled('div')(_objectSpread(_objectSpread({}, sharedLayout), {}, _defineProperty({
  paddingBottom: '70px!important',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  '.EmbersTemplate-marketingGroup-item': {},
  '@media screen and (max-width: 1562px)': {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  width: '100%',
  padding: '0 24px 50px 24px'
})));
export var StyleMarketingBottom = styled('div')(_defineProperty({
  background: PROMETHEAN_NEUTRAL_MID_GREY,
  width: '100%',
  padding: '32px',
  textAlign: 'center',
  rowGap: 24,
  '.EmbersTypography-root': {
    margin: '0 !important'
  }
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  padding: '0 24px'
}));
export var StyleGuestBottom = styled('div')(_defineProperty({
  background: PROMETHEAN_NEUTRAL_MID_GREY,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  rowGap: 24,
  padding: '32px',
  textAlign: 'center',
  '.EmbersTypography-root': {
    margin: '0 !important'
  },
  button: {
    width: 'fit-content'
  }
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  padding: '32px 24px'
}));